<style lang="scss" scoped>
.equ {
  position: absolute;
  width: 416px;
  height: 198px;
  left: 107px;
  top: 801px;
  margin-top: 20px;
  .door {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    .num {
      height: 92px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p:nth-child(2) {
        font-family: "dina";
        font-size: 48px;
      }
      .open {
        color: rgba(45, 130, 255, 1);
      }
      .close {
        color: #f1802f;
      }
    }
  }
}
</style>

<template>
  <div class="equ">
    <custom-plane
      title="消防卷帘门"
      :iconImg="require('@/assets/compImg/fireIcon/firedoor.png')"
    >
      <div class="door">
        <div class="num">
          <p>正常数量</p>
          <p class="open">{{ openNum }}</p>
        </div>
        <div class="num">
          <p>故障数量</p>
          <p class="close">{{ closeNum }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    openNum: Number,
    closeNum: Number,
  },
};
</script>
